const textPrimary = 'rgba(0,0,0, .87)';
const textSecondary = 'rgba(0,0,0, .54)';
const divider = 'rgba(0, 0, 0, 0.12)';

const primary = '#2B81E5';

const action = 'rgba(0, 0, 0, 0.04)';

const spacing = (...args) => args.map(x => `${x * 8}px`).join(' ');
const rnd = () => (Math.random() + 1).toString(36).substring(7);
export const className = (name, prefix = '.') => `${prefix}mop-debug-${name}`;

export const css = `
  ${className('drawer')} {
    font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
		position: fixed;
		top: 0;
		bottom: 0;
		right: 0;
		width: 500px;
		z-index: 9999999999;
		display: flex;
		transition: .225s transform;
		transform: translateX(100%);
  }

	${className('drawer')} * {
		font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
	}

	${className('drawer')}${className('open')} {
		transform: translateX(0);
	}

	${className('toggle-button')} {
    position: absolute;
    top: 20px;
    left: 0;
    transform: translateX(calc(-100% - 20px));
    background-color: #fff;
    padding: ${spacing(1.5)};
    border-radius: 100px;
    box-shadow: rgba(0, 0, 0, 0.05) -3px 3px 4px -4px, rgba(0, 0, 0, 0.03) 0px 0px 12px 2px, rgba(0, 0, 0, 0.05) 0px 3px 7px 3px;
		transition: background-color, transform, visibillity, opacity 0.2s .3s;
		appearance: none;
		border: 0;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: ${spacing(1)};
		color: ${textSecondary};
		font-weight: 600;
		font-size: 14px;
	}

	${className('toggle-button')}${className('shrink')} {
		transform: scale(0);
		opacity: 0;
		visibillity: hidden;
	}

	${className('toggle-button')}:hover {
		background-color: #fafafa;
	}

	${className('toggle-button')} span {
		position: absolute;
    font-size: 7px;
    background-color: ${textSecondary};
    border-radius: 20px;
    color: rgba(255,255,255,.87);
    padding: 1px 3px;
    white-space: nowrap;
    left: 50%;
    bottom: -5px;
    transform: translateX(-50%);
    font-weight: 600;
    display: block;
	}

	${className('icon-button')} {
		width: 40px;
		height: 40px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: ${textSecondary};
		transition: background-color .2s;
		border-radius: 100%;
		cursor: pointer;
	}

	${className('icon-button')}:hover {
		background-color: ${action};
	}

	${className('inner')} {
		background-color: #eee;
		color: ${textPrimary};
		display: flex;
		flex-direction: column;
		flex: 1;
	}
	
	${className('drawer')}${className('open')} ${className('inner')} {
		box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px;
	}

  ${className('header')} {
    background-color: #fff;
		padding: ${spacing(2, 2)};
		border-bottom: 1px solid ${divider};
    display: flex;
		justify-content: space-between;
    align-items: center;
		z-index: 10;
  }

  ${className('logo')} {
    width: 24px;
    height: 24px;
  }

	${className('icon')} {
		width: 24px;
		fill: currentColor;
	}

  ${className('title')} {
		font-size: 20px;
		font-weight: 600;
  }

  ${className('content')} {
		flex-grow: 1;
		overflow-x: hidden;
		overflow-y: auto;
		padding: ${spacing(3)};
	}
  
  ${className('subheader')} {
		font-size: 16px;
		margin-bottom: ${spacing(0.5)};
		font-weight: 600;
		color: ${textSecondary};
		display: flex;
		justify-content: space-between;
	}

	${className('rule')} {
		padding: ${spacing(1.5)};
		border-radius: 4px;
		background-color: #fff;
		margin-bottom: ${spacing(1)};
		border: 1px solid ${divider};
		transition: background-color .2s;
	}

	${className('rule')}:not(${className('open')}):hover {
		background-color: #fafafa;
	}

	${className('rule-header')} {
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
	}

	${className('right-content')} {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
	}

	${className('triangle')} {
		width: 0px;
		height: 0px;
		border-style: solid;
		border-width: 0 6px 6px 6px;
		border-color: transparent transparent rgba(0, 0, 0, .87) transparent;
		transform: rotate(180deg);
		margin-left: ${spacing(1)}
	}

	${className('rotate')} {
		transform: rotate(0);
	}

	${className('form-name')} {
		font-weight: 500;
	}

	${className('form-type')} {
		color: ${textSecondary};
		font-weight: 600;
		font-size: 13px;
	}

	${className('conditions-container')} {
		padding: ${spacing(2, 0)};
		border-top: 1px solid ${divider};
		margin-top: ${spacing(2)};
	}

	${className('condition-container')}:not(:first-of-type) {
		margin-top: ${spacing(3)}
	}

	${className('condition-container')}:last-of-type {
		padding-bottom: 0;
	}

	${className('condition-title-container')} {
		margin-bottom: ${spacing(0.5)};
		display: flex;
		align-items: center;
	}

	${className('condition-title')} {
		font-size: 13px;
		font-weight: 600;
		display: flex;
		justify-content: space-between;
		flex-grow: 1;
		color: ${textSecondary};
	}

	${className('session')} {
		color: ${textSecondary};
		font-weight: 400;
		font-size: 11px
	}
	
	${className('indicator-container')} {
		display: flex;
		align-items: center;
		font-size: 12px;
	}
	${className('indicator-container')} svg {
		width: 16px;
	}

	${className('indicator-container')}${className('small')} svg {
		width: 12px;
	}

	${className('condition-rule-container')} {
		margin: ${spacing(1, 0)};
		display: flex;
		align-items: center;
	}

	${className('condition-rule')} {
		display: flex;
		align-items: center;
		font-size: 14px;
	}

	${className('indicator-dot')} {
		width: 8px;
		height: 8px;
		border-radius: 100%;
		margin-left: ${spacing(1)};
		opacity: 0.7;
	}

	${className('div-placement-container')} {
		padding-top: ${spacing(1)};
		border-top: 1px solid ${divider};
	}

	${className('platform')} {
		margin-top: ${spacing(2)};
		padding-top: ${spacing(1)};
		border-top: 1px solid ${divider};
		display: flex;
		justify-content: flex-end;
	}


	${className('active')} {
		color: green;
	}

	${className('not-active')} {
		color: red;
	}

	${className('active-bg')} {
		background-color: green;
	}

	${className('not-active-bg')} {
		background-color: red;
	}

	${className('actions')} {
		display: flex;
		justify-content: space-between;
		margin-bottom: ${spacing(2)};
		align-items: center;
	}

	${className('btn-with-icon')} {
		display: inline-flex;
		align-items: center;
	}
	${className('btn-with-icon')} svg {
		width: 20px;
		fill: ${primary};
		margin-left: ${spacing(0.5)}
	}

	${className('search-container')} {
		position: relative;
	}
	
	${className('search-container')} svg {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
		fill: ${textSecondary};
	}

	${className('search')} {
		appearance: none;
		border: 1px solid rgba(0, 0, 0, 0.23);
		border-radius: 4px;
		padding: 12px 12px 12px 36px;
		font-size: 16px;
		width: 220px;
	}

	${className('ml-1')} {
		margin-left: ${spacing(1)}
	}	
	${className('mr-1')} {
		margin-right: ${spacing(1)}
	}

	${className('inner')} [data-tooltip] {
		position: relative;
	}

	${className('inner')} [data-tooltip]:before {
		content: attr(data-tooltip);
		position: absolute;
		right: 0;
		top: 0;
		font-size: 11px;
		font-weight: 600;
		padding: 4px 6px;
		min-width: 0px;
		background: rgba(0, 0, 0, 0.5);
		border: 0;
		color: #fff;
		border-radius: 4px;
		box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
		opacity: 0;
		visibility: hidden;
		transition: all 0.3s;
		min-width: 200px;
		transform: translateY(-100%);
	}

	${className('inner')} [data-tooltip]:hover:before {
		opacity: 1;
		visibility: visible;
		transform: translateY(0);
	}

	${className('invalid-reason')} {
		font-size: 11px;
		color: ${textSecondary};
	}

	${className('divider')} {
		width: 100%;
		height: 1px;
		background-color: ${divider};
	}

	${className('btn-link')} {
		font-size: 12px;
		color: ${primary};
		appearance: none;
		border: 0;
		background: none;
		text-decoration: none;
		text-transform: uppercase;
		border-radius: 4px;
		font-weight: 600;
		cursor: pointer;
		padding: ${spacing(0.5, 1)};
		transition: background-color 0.2s;
		white-space: nowrap;
	}

	${className('btn-link')}[disabled] {
		opacity: .6;
		cursor: not-allowed;
	}

	${className('btn-medium')} {
		padding: ${spacing(0.75, 2)};
		font-size: 12px;
	}

	${className('btn-link')}:hover {
		background-color: ${action};
	}

	${className('chip')} {
		border: 1px solid ${divider};
		height: ${spacing(3)};
		color: ${textPrimary};
		display: inline-flex;
		justify-content: center;
		align-items: center;
		font-size: 11px;
		border-radius: 16px;
		padding:0 8px;
		white-space: nowrap;
	}

	${className('chip')}${className('active')} {
		color: ${primary};
		border-color: ${primary};
	}

	${className('space-between')} {
		display: flex;
		justify-content: space-between;
	}

	${className('show-anyway')} {
		align-self: end;
	}

	${className('flexer')} {
		display: flex;
		align-items: center;
		gap: ${spacing(1)}
	}

	${className('embedded-alert')} {
		font-size: 9px;
		color: ${textSecondary};
	}

	${className('flex')} {
		display: flex;
	}

	${className('version-container')} {
		font-size: 12px;
		display: flex;
		align-items: center;
		position: relative;
	}

	${className('version-label')} {
		margin-right: ${spacing(1)};
		font-weight: 400;
		color: ${textSecondary};
		transform: translateY(-14px);
    font-size: 9px;
		position: absolute;
	}

	${className('select-container')} {
		position: relative;
	}
	${className('select-container')}::after {
	  content: '';
		position: absolute;
		top: 50%;
		right: 10px;
		transform: translateY(-25%);
		width: 0;
		height: 0;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 5px solid rgba(0, 0, 0, 0.54);
		pointer-events: none;
	}

	${className('select-container')} select {
		width: 100%;
		padding: 4px 32px 4px 0;
		font-size: 12px;
		border: none;
		border-bottom: 1px solid rgba(0, 0, 0, 0.42);
		background-color: transparent;
		outline: none;
		transition: border-bottom-color 0.2s, box-shadow 0.2s;
		appearance: none;
		color: ${textPrimary};
	}

	${className('select-container')} select:hover,
	${className('select-container')} select:focus,
	${className('select-container')} select:active {
		border-bottom-color: rgba(0, 0, 0, 0.87);
		box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.87);
	}
`;
